// extracted by mini-css-extract-plugin
export default {"scope":"msS8d","link":"x0eDa","scope--is-active":"hqiUe","scope--is-child":"_8SSzT","icon":"w-AZW"};